export default {
    cn: {
        checkManager: {
            login: 'MT4经理账号',
            password: 'MT4经理密码',
            confirm: '验证',
            success: '保存成功',
        }
    },
    hk: {
        checkManager: {
            login: 'MT4經理賬號',
            password: 'MT4經理密碼',
            confirm: '驗證',
            success: '保存成功',
        }
    },
    en: {
        checkManager: {
            login: 'MT4 Login',
            password: 'MT4 Password',
            confirm: 'Confirm',
            success: 'successfully',
        }
    },
}


// WEBPACK FOOTER //
// ./src/language/checkManager.js